var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage03SolidStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 5.175C1.25 3.55957 2.56262 2.25 4.18182 2.25H19.8182C21.4374 2.25 22.75 3.55957 22.75 5.175V18.825C22.75 20.4404 21.4374 21.75 19.8182 21.75H4.18182C2.56262 21.75 1.25 20.4404 1.25 18.825V5.175ZM10 8.5C10 9.32843 9.32843 10 8.5 10C7.67157 10 7 9.32843 7 8.5C7 7.67157 7.67157 7 8.5 7C9.32843 7 10 7.67157 10 8.5ZM4.1804 19.8C3.64066 19.8 3.20312 19.3635 3.20312 18.825V16.7955L6.14503 13.8536C6.3714 13.6272 6.67843 13.5 6.99858 13.5C7.31872 13.5 7.62576 13.6272 7.85213 13.8536L9.99858 16L14.645 11.3536C14.8714 11.1272 15.1784 11 15.4986 11C15.8187 11 16.1258 11.1272 16.3521 11.3536L20.794 15.7955V18.825C20.794 19.3635 20.3565 19.8 19.8168 19.8H4.1804Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage03SolidStandard);
export default __webpack_public_path__ + "static/media/image-03-solid-standard.4bb2bfa02cea7562792746b0de9f91a2.svg";
export { ForwardRef as ReactComponent };